import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import PaysService from "@/integrations/service/pays.service";

export const usePays = () => {
  return useQuery({
    queryKey: queryKeys.pays,
    queryFn: PaysService.getAll,
  });
};

export const useCreatePays = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: PaysService.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.pays });
    },
  });
};

export const useUpdatePays = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: any) => PaysService.update(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.pays });
    },
  });
};

export const useDeletePays = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: PaysService.delete,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.pays });
    },
  });
};
